import { eventBus } from 'configs/eventBus';
import type { EventAlls } from 'configs/eventBus';

export default class Logger {

    public static error(message?: any, ...optionalParams: any[]): void {
        //console.error(message, optionalParams);
    }

    public static event(event: keyof EventAlls, message: string): void {
        //console.log(message);
        eventBus.emit(event, message);
    }

    public static console(message: string): void {
        console.log(message);
    }
}